import { styled } from "@material-ui/core/styles";

const FullWidthImage = styled("img")(({ grey }) => ({
  filter: grey ? "grayscale(100%)" : "",
  objectFit: "cover",
  width: "100%",
}));

export default FullWidthImage;
